module.exports = __webpack_public_path__ + "img/close-electron-login-btn.34839fc7.svg";